import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from '@/api/index';
import { CLIENT_URL } from '@/constants/index';

export const fiberApi = createApi({
  reducerPath: 'fiberApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Fiber'],
  endpoints: (builder) => ({
    fiberTariffs: builder.query({
      query: ({ lang }) => ({
        url: '/fiber/individual/tariffs/',
        method: 'GET',
        headers: { 'Accept-Language': lang },
        baseURL: CLIENT_URL,
      }),
    }),
    fiberCities: builder.query({
      query: ({ lang }) => ({
        url: '/fiber/cities/',
        method: 'GET',
        headers: { 'Accept-Language': lang },
        baseURL: CLIENT_URL,
      }),
    }),
    fiberStreets: builder.query({
      query: ({ cityId, lang }) => ({
        url: `/fiber/cities/${cityId}/streets/`,
        method: 'GET',
        headers: { 'Accept-Language': lang },
        baseURL: CLIENT_URL,
      }),
    }),
    fiberHouses: builder.query({
      query: ({ streetId, lang }) => ({
        url: `/fiber/streets/${streetId}/houses/`,
        method: 'GET',
        headers: { 'Accept-Language': lang },
        baseURL: CLIENT_URL,
      }),
    }),
    fiberConnectionRequest: builder.mutation({
      query: ({ data }) => {
        return {
          url: '/fiber/connection-requests/',
          method: 'POST',
          data,
          baseURL: CLIENT_URL,
        };
      },
    }),
  }),
});

export const hooks = {
  useFiberTariffs: fiberApi.useFiberTariffsQuery,
  useFiberCities: fiberApi.useFiberCitiesQuery,
  useFiberStreets: fiberApi.useFiberStreetsQuery,
  useFiberHouses: fiberApi.useFiberHousesQuery,
  useFiberConnectionRequest: fiberApi.useFiberConnectionRequestMutation,
};

export default fiberApi;
